<script>
import { mapState, mapActions } from 'vuex';
import routes from '@/scripts/constants/menu';
import { applyLanguage } from '@/scripts/language';
import { mobile } from '@/scripts/computed';
import { goTo } from '@/scripts/methods';
import { getAsset } from '@/scripts/utils';

export default {
  name: 'Menu',
  props: {
    modal: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isActive: false,
      hovered: null,
    };
  },
  watch: {
    mobile(val) {
      this.rearrange(val);
    },
  },
  computed: {
    ...mapState(['showModalMenu']),
    mobile,
  },
  created() {
    this.rearrange();
  },
  mounted() {},
  methods: {
    ...mapActions({ toggleModalMenu: 'toggleModalMenu' }),
    isDesktopMenuMargin(route) {
      const { mobile, routes } = this;

      if (mobile) return false;
      if (!route || !routes || !routes.find) return false;

      const routeSetup = routes.find(({ name }) => name === route.name);
      const result = !!(routeSetup && !routeSetup.disabled);

      return result;
    },
    rearrange(mobile = this.mobile) {
      const { modal } = this;

      this.routes = mobile
        ? modal
          ? /* mobile modal */
            routes.filter(({ mobileMain }) => !mobileMain)
          : /* mobile main (bottom) */
            routes.filter(
              ({ mobileMain, mobileOnly }) => mobileMain || mobileOnly
            )
        : /* desktop */
          routes.filter(({ mobileOnly }) => !mobileOnly);
    },
    showMore() {
      this.toggleModalMenu(true);
    },
    itemClick(setup = {}) {
      const { showModalMenu, modal } = this;
      const { path, handler } = setup;

      if (showModalMenu && modal) this.toggleModalMenu();

      if (path) {
        this.goTo(path);
      } else if (handler && this[handler]) {
        this[handler](setup);
      }
    },
    mouseHover(id, add = null) {
      this.hovered = add ? id : null;
    },
    applyLanguage,
    goTo,
    getAsset,
  },
};
</script>

<template>
  <div
    :class="{
      menu: true,
      mr30: isDesktopMenuMargin($route),
      'is-modal': modal,
      [$mq]: true,
    }"
  >
    <div class="menu__content">
      <!-- map -->
      <div
        v-for="route in routes"
        :class="{
          menu__item: true,
          'is-active': $route.name === route.name,
          disabled: route.disabled,
        }"
        :key="route.id"
      >
        <div
          @click="itemClick(route)"
          @mouseenter="mouseHover(route.name, 'add')"
          @mouseleave="mouseHover(route.name)"
          class="link-route"
        >
          <div class="link-route__img">
            <img
              :alt="route.name"
              :src="
                getAsset(
                  mobile && route.mobileIcon ? route.mobileIcon : route.icon,
                  {
                    path: 'menu',
                    modifier:
                      $route.name == route.name ||
                      (hovered === route.name && !route.mobileIcon)
                        ? 'active'
                        : '',
                  }
                )
              "
            />
          </div>
          <div class="link-route__title">
            {{ applyLanguage(route.id) }}
          </div>
          <div class="link-route__subtitle">Coming Soon</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import '@/styles/variables.scss';
.menu {
  width: 90px;
  flex-shrink: 0;
  background-color: #131717;

  &.mr30 {
    margin-right: 30px;
  }

  &__content {
    position: sticky;
    top: 0;
    left: 0;
  }

  &__item {
    width: 100%;
    height: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    & + &:not(.disabled) {
      margin-top: 10px;
    }

    button {
      width: 100%;
      height: 100%;
    }

    &.menu__item--main {
      height: 54px;
    }
    &.menu__item--tournaments {
      flex-direction: column;
      align-items: center;
      text-align: center;
      height: auto;
    }

    &.is-active {
      min-height: 72px;

      .link-route {
        min-height: 72px;
        background-color: transparentize(#ffc107, 0.9);

        .link-route__title {
          display: block;
        }
      }
    }

    &.disabled {
      min-height: 87px;

      .link-route__title {
        display: block;
      }
      .link-route__subtitle {
        display: block;
      }
    }
  }
}

.link-route {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  width: 100%;
  min-height: 50px;
  transition: all 0.2s;
  text-decoration: none;

  &__img {
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    user-select: none;

    img {
      max-height: 20px;
      width: auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }

  &__title {
    font-family: Poppins-SemiBold;
    font-size: 10px;
    line-height: 12px;
    color: #ffffff;
    margin-top: 10px;
  }

  &__subtitle {
    font-family: Poppins-Medium;
    font-size: 8px;
    line-height: 11px;
    color: #ffc107;
    margin-top: 3px;
    display: none;
  }
}

/*  */
@media (max-width: $mobile) {
  .menu {
    &.mobile {
      position: fixed;
      bottom: 0;
      left: 0;
      width: 100%;
      background: #131717;
      z-index: 9;

      .menu__content {
        display: flex;
        position: static;
      }

      .menu__item {
        flex-grow: 1;
      }

      .menu__item + .menu__item:not(.disabled) {
        margin-top: 0;
      }

      .menu__item.is-active {
        min-height: auto;

        .link-route {
          min-height: auto;
          height: 100%;
          opacity: 1;
        }
      }

      .link-route {
        opacity: 0.5;
        &__img {
          height: 16px;

          img {
            max-height: 16px;
          }
        }

        &__title {
          font-family: Poppins-Medium;
          font-size: 8px;
          line-height: 11px;
          margin-top: 7px;
        }
      }
    }

    &.is-modal {
      position: relative;
      z-index: initial;

      .menu__content {
        flex-direction: column;
        width: 100%;
      }

      .link-route {
        opacity: 1;
        flex-direction: row;
        justify-content: flex-start;
        padding: 5px 15px 5px 20px;
      }

      .link-route__img {
        height: 20px;
        margin-right: 14px;
        flex-shrink: 0;

        img {
          max-height: 20px;
        }
      }

      .link-route__title {
        margin-top: 0;
        font-size: 12px;
        line-height: 17px;
        flex-grow: 1;
      }

      .link-route__subtitle {
        flex-shrink: 0;
        margin-top: 0;
      }

      .menu__item.disabled {
        min-height: auto;
      }

      .menu__item:first-child {
        height: 80px;
        margin-bottom: 5px;

        .link-route {
          min-height: 54px;
          padding: 5px 14px;
        }

        .link-route__img {
          height: 15px;
          margin: 0;

          img {
            height: 100%;
            width: 138px;
          }
        }
      }
    }
  }
}

@media (min-width: $desktop) {
  .menu {
    .link-route {
      &__title {
        display: none;
      }
    }
  }
}
</style>
